export const CREDIT_CARD = 'credit-card';
export const MULTI_OPTION = 'multi-option';
